import {Time, TimeInterval} from 'yougile-util'
import {
  DataObjectId,
  DeadlineStickerValue,
  Hub,
  TimerStickerValue
} from 'yougile-model'
import {Sync} from '@client/sync'
import {globals} from '@extensions/globals-base'
import {Sticker} from '@extensions/sticker/sticker'
import {updateStickerDates} from './get-required-stickers'

export const refreshStickers = (hub: Hub): void => {
  const box = Sync.getCurrentSandbox()
  const stickerKeys = Object.keys(hub.stickers) as DataObjectId[]
  for (const stickerKey of stickerKeys) {
    const s = Sticker.getById(box, stickerKey)
    const origValue = hub.stickers[stickerKey]

    if (Sticker.getType(s) === 'timer') {
      const ti = TimeInterval.fromString('0s')
      const val: TimerStickerValue = {
        current: {
          time: origValue?.current?.time || ti.toString(),
          by: globals.currentUserId,
          timestamp: Time.now(),
          running: true
        },
        history: []
      }

      const fullValue = {
        ...val,
        history: [val.current]
      }

      hub.stickers[stickerKey] = fullValue
    }

    if (Sticker.getType(s) === 'deadline') {
      const deadlineValue = (origValue as DeadlineStickerValue)?.current
      if (origValue) {
        const now = Time.now()

        const deadlineStart = Time.startOfDay(deadlineValue.timestamp)
        const nowStart = Time.startOfDay(now)

        const shift =
          Time.day * Math.floor((nowStart - deadlineStart) / Time.day)

        updateStickerDates(origValue, shift)
      }
    }
  }
}
